// Team spaces state for /memory: the caller's home workspace, their site-chosen ACTIVE
// space, and the shared spaces they belong to. One fetch feeds the SpaceSwitcher (nav),
// the team bar (banner while a team space is active), and the TeamSpacesPanel (manage).
// Silent-auth like the other /me/* hooks — an unauthenticated view just renders nothing
// space-related. `refresh()` re-fetches after a mutation (create / add / remove).
import { useCallback, useEffect, useState } from "react";
import { listMyWorkspaces } from "../utils/api";

export default function useMyWorkspaces() {
  const [data, setData] = useState(null);   // { home, active, spaces } | null
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const live = await listMyWorkspaces();
      setData(live && typeof live === "object" ? live : null);
    } catch (_) {
      setData(null);                        // unauthenticated / unreachable → no space UI
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { data, loading, refresh };
}
